import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Avatar,
  Pagination,
} from "@mui/material";
import { TbRestore } from "react-icons/tb";
import RestoreModal from "../Models/RestoreModal";
import { GetRecycleuser } from "../Redux/Actions/AuthAction";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader/Loading";
import notfound from "../assets/images/not-found.png";
import { IoIosSearch } from "react-icons/io";
import useTitle from "../hooks/useTitle";
const RecycleBin = () => {
  useTitle("Recycle");
  const dispatch = useDispatch();
  const [selectedUser, setSelectedUser] = useState(null);
  const [page, setPage] = useState(1);
  const [cachedPages, setCachedPages] = useState({});
  const { loading } = useSelector((state) => state.Auth);
  const [search, setSearch] = useState("");
  const [openrestoremodal, setopenrestoremodal] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const { restore } = useSelector((state) => state.Auth);
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    setPage(1);
    setCachedPages({});
  }, [debouncedSearch]);

  useEffect(() => {
    const scrollToTop = () => {
      const mainContent = document.getElementById("main-content");
      if (mainContent) {
        mainContent.scrollTo({ top: 0, behavior: "smooth" });
      }
    };

    if (!cachedPages[page]) {
      dispatch(GetRecycleuser(page, debouncedSearch)).then((res) => {
        setCachedPages((prev) => ({
          ...prev,
          [page]: res?.data,
        }));
        scrollToTop();
      });
    }
  }, [dispatch, page, debouncedSearch]);

  const handleRestore = (user) => {
    setSelectedUser(user);
    setopenrestoremodal(true);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <Box sx={{ padding: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            mb: 2,
            gap: 1,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: "bold",
              color: "#424242",
              fontSize: { xs: "1rem", sm: "1.3rem" },
            }}
          >
            Recycle
          </Typography>
          <div className="flex flex-col w-full relative sm:max-w-80 ">
            <input
              type="text"
              onChange={handleSearch}
              value={search}
              placeholder="Search"
              className="w-full h-[40px] rounded-[7px] px-[42px] text-[14px]
                 text-[#131415] font-[500] w-full focus:outline-none focus:ring-[1px]
                  focus:ring-[#EF5A24] focus:border-[#EF5A24] hover:border-[1px] hover:border-[#EF5A24]
               border-[1px] border-[#CACACA] transition-all"
            />
            <span className="absolute top-[10px] left-3">
              <IoIosSearch size={22} className="text-[#0C0C0C66]/60" />
            </span>
          </div>
        </Box>

        <div className="w-full overflow-x-auto z-[0]">
          <Paper
            sx={{
              height: "auto",
              backgroundColor: "transparent",
            }}
          >
            <TableContainer sx={{ minHeight: "78vh" }} className="relative">
              <Table aria-label="sticky table">
                <TableHead sx={{ backgroundColor: "transparent" }}>
                  <TableRow className="!font-bold">
                    <TableCell
                      align="left"
                      className="!font-semibold"
                      sx={{ padding: "12px" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      align="left"
                      className="!font-semibold"
                      sx={{ padding: "12px" }}
                    >
                      Phone
                    </TableCell>
                    <TableCell
                      align="center"
                      className="!font-semibold"
                      sx={{ padding: "12px" }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <Loader />
                  ) : (
                    restore &&
                    restore?.data?.map((obj) => (
                      <TableRow key={obj.id}>
                        <TableCell align="left" sx={{ padding: "12px" }}>
                          <div className="flex items-center gap-2">
                            <Avatar src={obj?.profileImage} alt="image" />
                            <span className="text-nowrap">
                              {obj?.first_name} {obj?.last_name}
                            </span>
                          </div>
                        </TableCell>

                        <TableCell align="left" sx={{ padding: "12px" }}>
                          <span className="text-nowrap">
                            +{obj?.code} {obj?.phone}
                          </span>
                        </TableCell>

                        <TableCell align="center" sx={{ padding: "12px" }}>
                          <IconButton
                            sx={{ color: "#F1580C" }}
                            onClick={() => handleRestore(obj)}
                            color="error"
                            size="small"
                          >
                            <TbRestore size={23} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
              {!loading && restore?.data?.length === 0 && (
                <div className="flex flex-col justify-center items-center w-full h-[60vh]">
                  <img
                    src={notfound}
                    alt="Not Found"
                    style={{ width: "200px", height: "auto" }}
                  />
                  <span className="text-xl font-bold mt-6">
                    No data found
                  </span>
                </div>
              )}
            </TableContainer>

            <div className="flex justify-end pt-3 ">
              <Pagination
                shape="rounded"
                count={restore?.pagination?.totalPages}
                page={page}
                onChange={handlePageChange}
                sx={{
                  "& .MuiPaginationItem-root.Mui-selected": {
                    background:
                      "linear-gradient(to right, #EF5A24 1%, #F38157 99%)",
                    color: "#fff",
                  },

                  "@media (max-width: 960px)": {
                    fontSize: "0.75rem",
                    "& .MuiPaginationItem-root": {
                      minWidth: "auto",
                      padding: "8px",
                      margin: "2px",
                    },
                  },
                  "@media (max-width: 600px)": {
                    fontSize: "0.5rem",
                    "& .MuiPaginationItem-root": {
                      padding: "8px",
                      margin: "1px",
                    },
                  },
                }}
              />
            </div>
          </Paper>
        </div>
      </Box>
      <RestoreModal
        Open={openrestoremodal}
        setOpen={setopenrestoremodal}
        user={selectedUser}
        page={page}
        setPage={setPage}
        cachedPages={cachedPages}
        setCachedPages={setCachedPages}
        debouncedSearch={debouncedSearch}
        setDebouncedSearch={setDebouncedSearch}
      />
    </>
  );
};

export default RecycleBin;
